import { cookieConstants } from "./constants/cookieConstants";

const createCookies = (payload: any) => ({ type: cookieConstants.createCookieRequest, payload });

const updateCookies = (payload: any) => ({ type: cookieConstants.updateCookieRequest, payload });

const getCookies = (payload: any) => ({ type: cookieConstants.getCookieRequest, payload });

export const cookiesAction = {
    createCookies,
    updateCookies,
    getCookies,
};
